import { useTranslation } from 'react-i18next';
import { FarmOverviewRow } from '../../models/farms-overview';
import { deviceSyncColors } from '../DeviceSyncStatus/colors';

const num = (value: number) => value.toLocaleString();

/**
 * Animals a farm's mobile devices have queued and not sent yet - the headline of the farm dashboard's
 * unsynced device data card, raised to the overview so a stuck device is seen without opening every farm.
 *
 * Amber rather than red: the overview only knows the queue exists, not how long it has stood, and the farm
 * dashboard is where it is told apart from a device that is simply mid-sync.
 *
 * Renders nothing for a farm with nothing queued, and for a response that predates the field.
 */
export default function FarmSyncBadge({ farm }: { farm: FarmOverviewRow }) {
  const { t } = useTranslation();
  const pending = farm.pendingAnimalCount ?? 0;

  if (pending <= 0) return null;

  return (
    <span
      title={t('f-farms-overview-unsynced-badge-title', { count: farm.pendingDeviceCount ?? 0 })}
      className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2.5 py-0.5 text-xs font-medium text-gray-700"
    >
      <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: deviceSyncColors.delayed }} />
      {t('f-farms-overview-unsynced-badge', { count: pending, value: num(pending) })}
    </span>
  );
}
